<template functional>
	<span>
		<svg
			v-if="props.filled"
			xmlns="http://www.w3.org/2000/svg"
			:width="props.size"
			:height="props.size"
			viewBox="0 0 130 130"
		><path :style="`fill: ${props.color}`" d="M121.71729,35.47754l-15.10352,38A4.00035,4.00035,0,0,1,102.89648,76H45.81323l1.79566,11.999L95.999,87.98633H96a4,4,0,0,1,.001,8L44.16406,96h-.001A4.00033,4.00033,0,0,1,40.207,92.5918L29.64307,22H12a4,4,0,0,1,0-8H33.08887a4.00032,4.00032,0,0,1,3.956,3.4082L38.9292,30H118a4.00049,4.00049,0,0,1,3.71729,5.47754ZM53,105.5A6.5,6.5,0,1,1,46.5,99,6.5,6.5,0,0,1,53,105.5Zm-4,0a2.5,2.5,0,1,0-2.5,2.5A2.50286,2.50286,0,0,0,49,105.5Zm45,0A6.5,6.5,0,1,1,87.5,99,6.5,6.5,0,0,1,94,105.5Zm-4,0a2.5,2.5,0,1,0-2.5,2.5A2.50286,2.50286,0,0,0,90,105.5Z" /></svg>
		<svg
			v-else
			xmlns="http://www.w3.org/2000/svg"
			:width="props.size"
			:height="props.size"
			viewBox="0 0 130 130"
		><path :style="`fill: ${props.color}`" d="M121.71729,35.47754l-15.10352,38A4.00035,4.00035,0,0,1,102.89648,76H45.81323l1.79566,11.999L95.999,87.98633H96a4,4,0,0,1,.001,8L44.16406,96h-.001A4.00033,4.00033,0,0,1,40.207,92.5918L29.64307,22H12a4,4,0,0,1,0-8H33.08887a4.00032,4.00032,0,0,1,3.956,3.4082L44.616,68h55.56616L112.106,38H53.42529a4,4,0,1,1,0-8H118a4,4,0,0,1,3.71729,5.47754ZM53,105.5A6.5,6.5,0,1,1,46.5,99,6.5,6.5,0,0,1,53,105.5Zm-4,0a2.5,2.5,0,1,0-2.5,2.5A2.50286,2.50286,0,0,0,49,105.5Zm45,0A6.5,6.5,0,1,1,87.5,99,6.5,6.5,0,0,1,94,105.5Zm-4,0a2.5,2.5,0,1,0-2.5,2.5A2.50286,2.50286,0,0,0,90,105.5Z" /></svg>
	</span>
</template>

<script>
export default {
	name: 'CartIcon',
	props: {
		color: {
			type: String,
			default: '#2487C4'
		},
		filled: Boolean,
		size: {
			type: Number,
			default: 25
		}
	}
};
</script>